import React from 'react'
import { OneColorLogoProps, scaleDimensions } from './utils'

export const SamsungTvLogo: React.FC<OneColorLogoProps> = ({
  height = 32,
  color = '#141414',
  className,
}) => {
  const { width: scaledWidth, height: scaledHeight } = scaleDimensions(
    height,
    47,
    18
  )
  const hex = color

  return (
    <svg
      className={className}
      height={scaledHeight}
      width={scaledWidth}
      aria-label="SamsungTV"
      viewBox="0 0 680 230"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2317_1812)">
        <path
          d="M203.467 121.044V179.94L157.049 146.998L203.467 121.044Z"
          fill="#244A9A"
        />
        <path
          d="M111.13 121.044V179.94L157.049 146.998L111.13 121.044Z"
          fill="#95A948"
        />
        <path
          d="M157.049 62.1482L97.1553 95.5891H157.049V62.1482Z"
          fill="#FFDE14"
        />
        <path
          d="M157.049 62.1482L216.943 95.5891H157.049V62.1482Z"
          fill="#F0C3C0"
        />
        <path
          d="M157.049 146.998L97.6543 188.924H157.049V146.998Z"
          fill="#D3D80E"
        />
        <path
          d="M157.049 146.998L216.943 188.924H157.049V146.998Z"
          fill="#2DAFE6"
        />
        <path
          d="M97.6543 188.924H157.049V229.852L97.6543 188.924Z"
          fill="#FBEF82"
        />
        <path
          d="M216.943 188.924H157.049V229.852L216.943 188.924Z"
          fill="#AFDFF9"
        />
        <path
          d="M97.6543 95.5891H157.548V129.03L97.6543 95.5891Z"
          fill="#F18825"
        />
        <path
          d="M216.943 95.5891H157.049V129.03L216.943 95.5891Z"
          fill="#E94287"
        />
        <path
          d="M216.944 188.924V95.5891L157.049 129.03L97.6543 95.5891V188.924L111.13 198.407V121.044L157.049 146.998L203.467 121.044V198.407L216.944 188.924Z"
          fill={hex}
        />
        <path
          d="M393.132 154.984C398.123 152.988 402.615 149.993 406.109 145.501C410.102 140.51 412.099 134.021 412.099 127.034C412.099 122.542 411.1 118.049 409.603 114.556C408.106 110.563 405.61 107.568 402.615 104.573C399.621 102.078 395.628 99.5821 391.136 98.0847C386.644 96.5874 381.652 96.0883 376.162 96.0883H337.73V198.907H351.206V109.564H376.162C383.649 109.564 389.139 111.062 392.633 114.057C396.127 117.051 398.123 121.543 398.123 127.034C398.123 133.023 396.127 137.016 392.633 140.011C388.64 143.005 383.15 144.503 376.162 144.503H359.691V157.48H379.656L398.623 198.407H413.596L393.132 154.984Z"
          fill={hex}
        />
        <path
          d="M423.578 96.5874V109.564H454.524V198.907H468V109.564H498.945V96.5874H423.578Z"
          fill={hex}
        />
        <path
          d="M281.829 96.5874H270.349L230.919 198.907H245.393L257.871 166.963H295.305L307.783 198.907H321.758L281.829 96.5874ZM262.363 154.984L276.339 118.549L290.314 154.984H262.363Z"
          fill={hex}
        />
        <path
          d="M77.1905 158.977C75.6931 155.483 73.6966 152.489 71.201 149.993C68.7054 147.497 65.7108 145.501 62.2169 143.505C58.7231 142.007 54.7301 140.51 50.7372 140.011L32.2698 137.515C30.2734 137.016 28.2769 137.016 26.2804 136.018C24.783 135.519 23.2857 134.52 21.7883 133.522C20.7901 132.524 19.7919 131.027 18.7936 129.529C18.2945 128.032 17.7954 126.035 17.7954 123.54C17.7954 121.044 18.2945 118.549 19.2927 117.051C20.291 115.055 21.7883 113.557 23.2857 112.06C25.2822 110.563 27.7778 109.065 30.2733 108.067C33.2681 107.069 36.2627 107.069 39.2575 107.069C43.2504 107.069 47.2434 107.568 50.2381 109.065C53.2328 110.064 55.7284 112.06 57.7248 114.057C59.2222 115.554 60.2204 117.051 60.7196 119.048C61.2187 120.545 62.2169 122.542 62.2169 125.037L62.716 127.533H76.1922L75.6931 124.039C75.194 120.046 74.6949 116.552 73.1975 113.557C71.7002 110.563 69.7037 108.067 67.7072 105.572C64.7125 102.078 60.2204 99.083 55.2293 97.0865C50.2381 95.09 44.7478 94.0918 39.2575 94.0918C34.2663 94.0918 29.7742 95.09 25.2822 96.5874C20.7901 98.0847 16.7972 100.58 13.3033 103.575C10.8077 106.071 8.31213 109.065 6.31566 112.06C4.31919 115.554 3.32096 119.547 3.32096 124.039C3.32096 128.032 3.82009 132.025 5.31744 135.019C6.8148 138.014 8.81125 141.009 11.3068 143.505C13.8024 146 16.7972 147.497 19.7919 148.995C22.7866 150.492 26.2804 150.991 30.2733 151.49L48.2416 153.986C50.7372 154.485 53.2328 154.984 55.2293 155.982C57.2257 156.981 58.7231 157.979 60.2204 159.476C61.7178 160.974 62.716 162.471 63.2151 163.968C63.7143 165.466 64.2134 167.462 64.2134 169.459C64.2134 171.954 63.7143 174.45 62.716 175.947C61.7178 177.944 60.7195 179.441 59.2222 180.938C56.7266 182.935 54.231 184.432 50.7372 185.43C47.2434 186.429 43.2504 186.928 39.2575 186.928C35.7636 186.928 31.7707 186.429 28.776 184.931C25.2822 183.933 22.7866 181.937 20.291 179.94C18.7936 178.443 17.2963 176.446 16.298 173.951C15.2998 171.954 14.3015 169.459 14.3015 166.963L13.8024 163.968H-0.172852L0.326259 167.462C0.825377 171.455 1.82361 175.448 3.32096 178.942C4.81832 182.436 7.31392 185.43 9.80951 188.425C13.3033 192.418 17.7954 194.914 22.7866 196.91C27.7778 198.907 33.268 199.905 39.2575 199.905C45.2469 199.905 50.7372 198.907 55.7284 197.409C60.7196 195.912 65.2116 192.917 68.7054 189.423C71.201 186.928 73.1975 183.933 74.6949 180.938C76.1922 177.445 77.1905 173.452 77.1905 168.96C79.1869 165.965 78.6878 162.471 77.1905 158.977Z"
          fill={hex}
        />
        <path
          d="M631.711 199.406H640.695L680.125 96.0883H669.644L636.203 184.931L601.764 96.0883H526.397V105.572H558.839V199.406H568.323V105.572H595.275L631.711 199.406Z"
          fill={hex}
        />
        <path
          d="M203.467 121.044V198.407L216.943 188.924V95.5891L157.049 129.03V146.998L203.467 121.044Z"
          fill={hex}
        />
        <path
          d="M7.63636 21.7944C2.12121 20.1495 0.848484 15.6261 0.848484 11.9252V10.6916C0.848484 3.70093 4.66667 0 12.7273 0H16.5455C22.9091 0 26.7273 2.46728 26.7273 9.04672C26.7273 10.6916 25.8788 11.9252 23.7576 11.9252C21.6364 11.9252 20.7879 10.6916 20.7879 9.04672C20.7879 6.57943 19.0909 5.34578 16.5455 5.34578H12.7273C8.48485 5.34578 6.36364 6.99065 6.36364 10.6916V11.9252C6.36364 14.3925 8.0606 16.0374 9.75757 16.4486L20.7879 20.5608C25.4545 22.2056 28 25.4953 28 30.8411V32.8972C28 39.8879 24.1818 44 16.1212 44H10.1818C3.81818 44 0 41.5327 0 34.9533C0 33.3084 0.848484 32.0748 2.9697 32.0748C5.09091 32.0748 5.93939 33.3084 5.93939 34.9533C5.93939 37.4206 7.63636 38.6542 10.1818 38.6542H16.5455C20.7879 38.6542 22.9091 36.5981 22.9091 32.8972V30.8411C22.9091 28.3738 21.6364 26.729 19.9394 25.9065L7.63636 21.7944Z"
          fill={hex}
        />
        <path
          d="M48.7143 12C55.1429 12 59 15.6234 59 21.2597V40.1818C59 41.7922 58.1429 43 56 43H44.4286C38.4286 43 35 40.5844 35 34.9481V30.5195C35 24.8831 38.8571 22.4676 44.4286 22.4676H53.4286V21.2597C53.4286 18.4416 51.7143 17.2338 49.1429 17.2338H41C39.2857 17.2338 38 16.4286 38 14.8182C38 13.2078 39.2857 12.4026 41 12.4026H48.7143V12ZM53 37.7662V27.2987H44C41.4286 27.2987 40.1429 28.5065 40.1429 30.5195V34.9481C40.1429 36.5584 41.4286 38.1688 44 38.1688H53V37.7662Z"
          fill={hex}
        />
        <path
          d="M96.6471 22.9367C96.6471 19.2912 95 17.2658 90.8824 17.2658H87.5882V41.1646C87.5882 42.7848 86.7647 44 84.7059 44C82.6471 44 81.8235 42.7848 81.8235 41.1646V17.2658H72.7647V41.1646C72.7647 42.7848 71.9412 44 69.8824 44C67.8235 44 67 42.7848 67 41.1646V14.8355C67 13.2152 67.8235 12 69.8824 12H90.8824C98.2941 12 102 16.0507 102 22.9367V41.1646C102 42.7848 101.176 44 99.1176 44C97.0588 44 96.2353 42.7848 96.2353 41.1646V22.9367H96.6471Z"
          fill={hex}
        />
        <path
          d="M119.103 44C113.31 44 110 42 110 36.8C110 35.2 110.828 34 112.897 34C114.966 34 115.379 35.2 115.793 36.8C115.793 38 117.034 39.2 119.517 39.2H124.483C127.379 39.2 128.207 37.6 128.207 36V34C128.207 32.4 127.379 32 126.138 31.2L116.621 28.8C112.897 27.6 111.241 25.2 111.241 21.6V20C111.241 14.4 114.552 12 120.345 12H123.655C129.448 12 132.759 14 132.759 19.2C132.759 20.8 132.345 22 129.862 22C127.793 22 127.379 20.8 126.966 19.2C126.966 18 125.724 16.8 123.655 16.8H120.345C117.448 16.8 116.621 18.4 116.621 20V21.6C116.621 22.8 117.448 23.6 118.69 24.4L128.207 26.8C131.931 28 134 30 134 34V36C134 41.6 130.69 44 124.897 44H119.103Z"
          fill={hex}
        />
        <path
          d="M145.966 32.405C145.966 35.9367 147.621 37.8987 151.759 37.8987H159.207V14.7468C159.207 13.1772 160.034 12 162.103 12C164.172 12 165 13.1772 165 14.7468V40.2531C165 41.8228 164.172 43 162.103 43H152.172C144.31 43 141 39.0759 141 32.405V14.7468C141 13.1772 141.828 12 143.897 12C145.966 12 146.793 13.1772 146.793 14.7468V32.405H145.966Z"
          fill={hex}
        />
        <path
          d="M193.034 22.9367C193.034 19.2912 191.379 17.2658 187.241 17.2658H179.793V41.1646C179.793 42.7848 178.966 44 176.897 44C174.828 44 174 42.7848 174 41.1646V14.8355C174 13.2152 174.828 12 176.897 12H186.828C194.276 12 198 16.0507 198 22.9367V41.1646C198 42.7848 197.172 44 195.103 44C193.034 44 192.207 42.7848 192.207 41.1646V22.9367H193.034Z"
          fill={hex}
        />
        <path
          d="M230.186 46.4513C230.186 52.823 226.525 58 218.797 58H212.288C211.068 58 209.441 57.2035 209.441 55.6106C209.441 54.0177 210.661 53.2212 212.288 53.2212H219.203C223.271 53.2212 225.305 50.4336 225.305 46.8496V43.6637H217.983C210.661 43.6637 207 39.6814 207 32.9115V24.5487C207 17.7787 210.661 13 218.39 13H228.153C230.186 13 231 14.1947 231 15.7876V46.4513H230.186ZM217.983 17.3805C213.915 17.3805 212.288 20.1681 212.288 23.7522V32.115C212.288 35.6991 213.915 37.6903 217.983 37.6903H225.305V17.3805H217.983Z"
          fill={hex}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_1812">
          <rect width="680" height="230" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
